export class FilterWithholdingCatalog{
    description!: string;
}